import { mount } from "svelte";
import Sidebar from "../elements/Sidebar/Sidebar.svelte";

export const initializeSidebar = () =>
  mount(Sidebar, {
    target: document.getElementById("sidebar-wrapper"),
  });
